import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionInvoicesTransferSlideout extends Layout {
    layoutTransferSlideout: Layout;
}
